
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/d/account/gifts/redeem",
      function () {
        return require("private-next-pages/d/account/gifts/redeem.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/d/account/gifts/redeem"])
      });
    }
  